import { FunctionComponent, PropsWithChildren } from "react";
import { cn } from "../../utils/cn";

export interface FlexLayoutProps {
  className?: string;
  tight?: boolean;
}

/**
 *
 */
export const FlexLayout: FunctionComponent<
  PropsWithChildren<FlexLayoutProps>
> = ({ className, children, tight }) => {
  const css = cn(
    className,
    "flex flex-wrap  md:gap-10",
    tight ? "gap-5 md:gap-10" : "gap-1 md:gap-2",
  );
  return <div className={css}>{children}</div>;
};
